import { combineReducers } from 'redux';

import authReducer from './authReducer';
import assetsReducer from './assetsReducer';

export default combineReducers({
    authReducer,  
    assetsReducer
});
